export const UPDATE_LICENSE = 'UPDATE_LICENSE';